// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"4fffce1ecfea467ce4da","678":"dae4a7247d3a37b3881c","883":"98c74cde2d78a8296eba"}[chunkId] + ".js";
};